import { FloatButton, Popover } from 'antd';
import { useEffect, useState } from 'react';
import RobotIcon from '../../Assets/robot.png';
import Resume from '../../Pages/Hero/Puneet.pdf';
import { extractTextFromPDF } from '../../Utils/utils.js';
import Chatbot from '../Chatbot/Chatbot.jsx';
import './trigger.scss';

const Trigger = ({ showChatbot, setShowChatbot }) => {

  const [resumeText, setResumeText] = useState('');

  const handleTriggerClick = () => {
    setShowChatbot(true);
  }

  // loading resume on render
  useEffect(() => {
    const loadResume = async () => {
      const response = await fetch(Resume);
      const buffer = await response.arrayBuffer();
      const text = await extractTextFromPDF(buffer);
      setResumeText(text);
    }

    loadResume();
  }, []);

  return (
    <div className='chatbot-trigger'>
      <Popover open={showChatbot} title='' trigger='click'
        content={<Chatbot setShowChatbot={setShowChatbot} resumeText={resumeText} />}
      >
        <FloatButton
          onClick={handleTriggerClick}
          icon={
            <img
              title='Need help?'
              src={RobotIcon}
              alt="Robot"
              style={{ width: "100%", height: "100%" }}
            />
          }
          shape='circle'
        />
      </Popover>
    </div>
  )
}

export default Trigger
